

















export default {
  name: 'ProgressModal',
  props: {
    id: { type: String, default: 'progress-modal' },
    visible: { type: Boolean, required: true },
    bodyClass: { type: String, default: 'progress-modal' }
  }
};
